export const MDI_ICONS = {
    username: 'mdi-account',
    socialSecurityNumber: 'mdi-security',
    address: 'mdi-city',
    zipCode: 'mdi-zip-box',
    percent: 'mdi-percent',
    amount: 'mdi-cash',
    car: 'mdi-van-passenger',
    toMultiply: 'mdi-multiplication',
    toAdd: 'mdi-plus',
    dollar: 'mdi-currency-usd',
    building: 'mdi-account-multiple-outline',
};
